import { render, staticRenderFns } from "./ConfirmDeletePosts.vue?vue&type=template&id=5f26810b&scoped=true&"
import script from "./ConfirmDeletePosts.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeletePosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26810b",
  null
  
)

export default component.exports